/* eslint-disable no-dupe-keys */
export default {
  vin_blacklist: {
    name: 'VIN黑名单',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '名称',
      vin: 'VIN',
      block_periods: '拦截时间',
      vin_block_charge_stations: '适用电站',
      description: '说明',
      blocked_count: '拦截次数',
      created_at: '创建时间',
      updated_at: '更新时间',
      charge_station: '充电站',
      charge_stations: '充电站',
      service_provider: '运营商',
      block_station_scope: '拦截范围',
      max_soc: '充电最大 SOC',
      user: '用户'
    },
    // Enum的属性
    block_station_scope: {
      block_all_stations: '所有电站',
      block_specified_stations: '指定电站'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询名称/VIN'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息'
    },
    // 标签
    labels: {
      total_count: 'VIN黑名单数量',
      total_blocked_count: '拦截总数'
    },
    // 校验
    validates: {
      periods_has_intersaction: '拦截时间段存在交集'
    }
  }
}
